export default __webpack_public_path__ + "static/media/localizacao-mapa.cd0cb1d1.png";